import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { InstructorService } from 'src/app/service/instructor.service';
import { Instructor } from 'src/app/model/instructor.model';
import { ReservationSubItem } from 'src/app/model/reservation.model';
import { Grouptype } from 'src/app/model/grouptype';
import { DataService } from 'src/app/service/data.service';
@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {
  public instructors: Instructor[];
  selectedInstructorId = -1;
  id: number;
  reservationItem: ReservationSubItem;
  filterName: string;

  constructor(private router: Router, private instructorService: InstructorService,  private dataService: DataService) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.reservationItem = this.router.getCurrentNavigation().extras.state.reservationSubItem as ReservationSubItem;
    }
  }

  ngOnInit() {
    this.instructorService.getAll().subscribe(data => (this.instructors = data as Instructor[]));
  }

  getRecord(instructor) {
    this.selectedInstructorId = instructor.user.id;
    
  }

  getFilteredInstructors(): Instructor[] {
    if (this.filterName && this.filterName !== '') {
      return this.instructors.filter(i => (i.user.name + i.user.lastName).toLowerCase().includes(this.filterName.toLowerCase()));
    }
    return this.instructors;
  }
}
